import styled from 'styled-components'
import COLORS from '@colors'

export const List = styled.div`
  width: 100%;
`
export const Item = styled.div`
  height: fit-content;
  color: ${COLORS.gray87};
`

export const ItemHeader = styled.div`
  height: 20px;
  letter-spacing: 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  color: ${COLORS.gray87};
`
export const ItemBody = styled.div`
  height: fit-content;
  padding-left: 38.5px;
  margin-top: 16.5px;
  letter-spacing: 0;
  color: ${COLORS.gray87};
  border-left: 1px solid ${COLORS.whiteD};
  transition: 0.3s ease;
`

export const ItemHeaderDate = styled.div`
  font: Bold 14px/17px Barlow;
  padding-left: 21.5px;
`

export const ItemHeaderGreenBall = styled.div`
  height: 18px;
  width: 18px;
  background-color: ${COLORS.lightGreen};
  border: 1px solid ${COLORS.lightGreen};
  position: relative;
  left: -9px;
  border-radius: 50%;
`
